import { graphql } from 'react-relay';

export const AIPresetsQuery = graphql`
    query aiPresetsQuery($toolId: String!, $presetType: String, $categoryId: Int) {
        aiPresets(toolId: $toolId, presetType: $presetType, categoryId: $categoryId) {
            id
            name
            presetType
            categoryId
            categoryName
            prompt
            negativePrompt
            imageUrl
            factor
            description
            sortOrder
            previewUrl
            sellerID
        }
    }
`;
